const MONTH_VALUE_REG = /^\d{1,2}$/;
const YEAR_VALUE_REG = /^\d{4}$/;
const DAY_VALUE_REG = /^\d{1,2}$/;

export function isLeapYear(year: number) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

export function validateYearFieldValue(yearValue: string) {
    return !yearValue || YEAR_VALUE_REG.test(yearValue);
}

export function validateMonthFieldValue(monthValue: string) {
    if (!monthValue) {
        return true;
    }
    if (!MONTH_VALUE_REG.test(monthValue)) {
        return false;
    }

    const month = parseInt(monthValue, 10);

    return month > 0 && month <= 12;
}

export function getDaysInMonth(yearValue = '', monthValue = '') {
    if (!validateMonthFieldValue(monthValue)) {
        return 31;
    }

    const month = parseInt(monthValue, 10);
    if (month === 2) {
        return !validateYearFieldValue(yearValue) ||
            yearValue === '' ||
            isLeapYear(parseInt(yearValue, 10))
            ? 29
            : 28;
    } else if ([4, 6, 9, 11].includes(month)) {
        return 30;
    }

    return 31;
}

export function validateDayFieldValue(dayValue: string, yearValue = '', monthValue = '') {
    if (!dayValue) {
        return true;
    }
    if (!DAY_VALUE_REG.test(dayValue)) {
        return false;
    }

    const day = parseInt(dayValue, 10);

    return day > 0 && day <= getDaysInMonth(yearValue, monthValue);
}
